import axios from "axios";
import { ACCESS_TOKEN, BASE_URL, CLIENT_REF } from "../config/app.config";

const API_URL = `${BASE_URL}desktop-template`;

/**
 * Get all desktop templates
 */
export const getAllTemplates = async () => {
    try {
        const response = await axios.get(`${API_URL}/get-all/${CLIENT_REF}`, {
            headers: {
                "Content-Type": "application/json",
                "x-access-token": ACCESS_TOKEN,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

/**
 * Get the currently active template
 */
export const getActiveTemplate = async () => {
    try {
        const response = await axios.get(`${API_URL}/get-active/${CLIENT_REF}`, {
            headers: {
                "Content-Type": "application/json",
                "x-access-token": ACCESS_TOKEN,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

/**
 * Upload a new desktop template
 * @param {File} file - The zip file to upload
 * @param {string} version - Template version (e.g., "1.0.0")
 * @param {string} description - Template description
 * @param {string} uploadedBy - Admin user email
 */
export const uploadTemplate = async (file, version, description, uploadedBy) => {
    try {
        const formData = new FormData();
        formData.append('templateFile', file);
        formData.append('version', version);
        formData.append('description', description || '');
        formData.append('uploadedBy', uploadedBy || 'admin');

        const response = await axios.post(`${API_URL}/upload/${CLIENT_REF}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "x-access-token": ACCESS_TOKEN,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

/**
 * Set a template as active
 * @param {string} templateId - Template ID to activate
 */
export const setActiveTemplate = async (templateId) => {
    try {
        const response = await axios.post(`${API_URL}/set-active/${CLIENT_REF}/${templateId}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "x-access-token": ACCESS_TOKEN,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

/**
 * Delete a template
 * @param {string} templateId - Template ID to delete
 */
export const deleteTemplate = async (templateId) => {
    try {
        const response = await axios.post(`${API_URL}/delete/${CLIENT_REF}/${templateId}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "x-access-token": ACCESS_TOKEN,
            },
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};